import { Component, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import {MatLegacyPaginator as MatPaginator} from '@angular/material/legacy-paginator';
import { EnvService } from '../services/env.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { debounceTime, Subscription } from 'rxjs';
import { CmdbDatabasesFilter } from './cmdb-databases.filter';
import { SettingsPersistenceService } from '../services/settings-persistence.service';
import { AuthService } from '../services/auth.service';
import { LookupService } from '../srvs/lookup';

@Component({
  selector: 'micro-cmdb-databases',
  templateUrl: './cmdb-databases.component.html',
})
export class CmdbDatabasesComponent {
  dataSource = new MatTableDataSource<any>();

  @ViewChild(MatPaginator, {static: true}) paginator!: MatPaginator;
  pageSettings!: SettingsPersistenceService;
  filter = new CmdbDatabasesFilter(this.auth);
  applicationNames = new Map<string, string>();
  selectedApplication: any;
  private subscriptions = new Subscription();
  private loadSubscription?: Subscription;

  constructor(public auth: AuthService, private env: EnvService, private http: HttpClient,
              public lookupService: LookupService) {
  }

  ngOnInit(): void {
    // Setup the settings persistence service for this page
    this.pageSettings = new SettingsPersistenceService(sessionStorage, 'micro.cmdbDatabases');
    this.pageSettings
      .setFilter(this.filter)
      .setPaginator(this.paginator)
      .init();

    // Subscribe to filter changes with a debounce time to avoid excessive reloads
    this.subscriptions.add(this.filter.anyChange.pipe(debounceTime(500)).subscribe(change => {
      this.paginator.pageIndex = 0;
      this.reload();
    }));

    if (this.filter.applicationId) {
      this.subscriptions.add(this.http.get(`${this.env.e.url}/domain/cmdbApplications/${this.filter.applicationId}`)
        .subscribe(data => this.selectedApplication = data));
    }

    // Initial data load
    this.reload();
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
    this.loadSubscription?.unsubscribe();
    this.pageSettings.removeFilterListener();
    this.pageSettings.removePaginatorListener();
  }

  reload(): void {
    const params: HttpParams = this.filter.getParams()
      .set('page', String(this.paginator.pageIndex || 0))
      .set('size', String(this.paginator.pageSize || 20));

    this.loadSubscription?.unsubscribe();
    this.loadSubscription = this.http.get(`${this.env.e.url}/domain/cmdbDatabases`, {params}).subscribe(data => {
      const page = data as any;
      this.dataSource.data = page.content;
      this.paginator.pageIndex = page.number;
      this.paginator.pageSize = page.size;
      this.paginator.length = page.totalElements;
      for (const database of page.content) {
        if (database.applicationId && !this.applicationNames.has(database.applicationId)) {
          this.applicationNames.set(database.applicationId, database.applicationId);
          this.subscriptions.add(this.http.get(`${this.env.e.url}/domain/cmdbApplications/${database.applicationId}`)
            .subscribe((application: any) => {
              this.applicationNames.set(database.applicationId, application?.name || database.applicationId);
            }));
        }
      }
    });
  }
}
